module.exports = __webpack_public_path__ + "img/feature-2.5c0ad4fc.png";